var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadorderIcons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.186 2.753V6.349C14.186 6.836 14.38 7.304 14.726 7.649C15.0729 7.99437 15.5425 8.18819 16.032 8.188H20.157",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.568V17.136C20.2301 17.6964 20.0996 18.2474 19.8658 18.7571C19.6321 19.2669 19.2997 19.7253 18.888 20.106C18.4759 20.4885 17.9925 20.786 17.4654 20.9816C16.9383 21.1772 16.3778 21.2671 15.816 21.246H8.226C7.66074 21.2718 7.09594 21.1858 6.56398 20.993C6.03201 20.8001 5.54335 20.5041 5.126 20.122C4.71027 19.7403 4.37454 19.2797 4.13833 18.7671C3.90211 18.2545 3.77011 17.7001 3.75 17.136V6.862C3.76985 6.30157 3.90042 5.75062 4.13418 5.24088C4.36794 4.73115 4.70026 4.27271 5.112 3.892C5.52408 3.50952 6.00748 3.21198 6.53458 3.01637C7.06169 2.82077 7.62217 2.73093 8.184 2.752H13.898C14.7703 2.74892 15.6123 3.07166 16.259 3.657L19.219 6.379C19.5349 6.65108 19.7899 6.9866 19.9675 7.36374C20.1452 7.74089 20.2414 8.1512 20.25 8.568Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.499V17.273",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.106 13.35L12.441 10.685C12.3834 10.6266 12.3147 10.5803 12.239 10.5487C12.1633 10.5171 12.0821 10.5008 12 10.5008C11.918 10.5008 11.8368 10.5171 11.7611 10.5487C11.6854 10.5803 11.6167 10.6266 11.559 10.685L8.89404 13.351",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadorderIcons);
export default __webpack_public_path__ + "static/media/uploadorderIcons.c5e311475b17296f3b33ca300b3d5927.svg";
export { ForwardRef as ReactComponent };